export const SELECTED_REGION_QUERY_PARAM = 'selected_region';
export const SELECTED_REGION_STORAGE_KEY = 'snt:geo:selected-region';

export const normalizeRegionCode = (value?: string | null) => {
  if (!value) {
    return null;
  }

  const normalized = value.trim().toUpperCase();

  return /^[A-Z]{2}$/.test(normalized) ? normalized : null;
};

export const getSelectedRegionFromUrl = (url: URL = new URL(window.location.href)) =>
  normalizeRegionCode(url.searchParams.get(SELECTED_REGION_QUERY_PARAM));

export const getSelectedRegionFromStorage = (storage: Storage = localStorage) =>
  normalizeRegionCode(storage.getItem(SELECTED_REGION_STORAGE_KEY));

export const writeSelectedRegionToUrl = (url: URL, regionCode: string | null) => {
  url.searchParams.delete(SELECTED_REGION_QUERY_PARAM);

  if (regionCode) {
    url.searchParams.set(SELECTED_REGION_QUERY_PARAM, regionCode);
  }
};

export default (url: URL = new URL(window.location.href), storage: Storage = localStorage) =>
  getSelectedRegionFromUrl(url) ?? getSelectedRegionFromStorage(storage);
